"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisClient = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const IrisClientEventHandler_1 = require("../event_handler/IrisClientEventHandler");
const IrisClientState_1 = require("../state/IrisClientState");
const util_1 = require("../util");
/**
 * 通过engine.initialize创建的client将会是默认的一个client
 * 默认固定在this._engine.irisClientManager.irisClientList[0]
 * engineEx.joinChannelEx不会使用,只有engine.joinChannel才会使用
 * 轨道发布在哪个channel不受此逻辑影响,轨道是否发布只看client的irisClientState配置来
 */
class IrisClient {
    constructor(engine, connection) {
        this.audioTrackPackages = new Array();
        // AUDIT-v18: double-release guard. release() può essere invocato
        // simultaneamente da molteplici path (leaveChannel + leaveChannelEx +
        // onConnectionLost + error path join) → NPE su agoraRTCClient undefined
        // o doppia rimozione da irisClientList. Flag interno gate re-entry.
        this._releasing = false;
        this._released = false;
        this._engine = engine;
        this.irisClientState = new IrisClientState_1.IrisClientState(this._engine.globalState);
        if (connection) {
            this.connection = connection;
        }
        else {
            this.connection = {
                channelId: '',
                localUid: 0,
            };
        }
        this.id = `irisClient_${Math.floor(Math.random() * new Date().getTime())}`;
        this._engine.irisClientManager.irisClientList.push(this);
    }
    setClientConfig() {
        var _a;
        let irisClientState = this.irisClientState;
        let config = {
            codec: ((_a = irisClientState.videoEncoderConfiguration) === null || _a === void 0 ? void 0 : _a.codecType)
                ? util_1.AgoraTranslate.NATIVE_RTCVIDEO_CODEC_TYPE2SDK_CODEC(irisClientState.videoEncoderConfiguration.codecType)
                : 'vp8',
            mode: irisClientState.channelProfile
                ? util_1.AgoraTranslate.NATIVE_RTC_CHANNEL_PROFILE_TYPE2SDK_MODE(irisClientState.channelProfile)
                : 'live',
        };
        if (irisClientState.clientRoleType != null) {
            config.role = util_1.AgoraTranslate.NATIVE_RTC_CLIENT_ROLE_TYPE2ClientRole(irisClientState.clientRoleType);
        }
        if (irisClientState.clientRoleOptions != null) {
            config.clientRoleOptions = util_1.AgoraTranslate.NATIVE_RTCClientRoleOptions2ClientRoleOptions(irisClientState.clientRoleOptions);
        }
        //如果调用过engine.setChannelProfile,整个频道的mode都将被这个值覆盖
        if (this._engine.globalState.channelProfile != null) {
            config.mode = util_1.AgoraTranslate.NATIVE_RTC_CHANNEL_PROFILE_TYPE2SDK_MODE(this._engine.globalState.channelProfile);
        }
        return config;
    }
    createClient(options) {
        var _a;
        if (options) {
            this.irisClientState.mergeChannelMediaOptions(options);
        }
        let irisClientState = this.irisClientState;
        let globalState = this._engine.globalState;
        let config = this.setClientConfig();
        this.agoraRTCClient = this._engine.globalState.AgoraRTC.createClient(config);
        //设置远端默认是 大流还是小流
        if (irisClientState.remoteDefaultVideoStreamType !== 0) {
            this.agoraRTCClient
                .setRemoteDefaultVideoStreamType(util_1.AgoraTranslate.NATIVE_RTCVIDEO_STREAM_TYPE2RemoteStreamType(irisClientState.remoteDefaultVideoStreamType))
                .then(() => { })
                .catch((e) => {
                util_1.AgoraConsole.error(`IrisClient.setup chain error: ${e}`);
            })
                .finally(() => { });
        }
        //设置指定的远端uid具体是大流还是小流
        for (let e of irisClientState.remoteVideoStreamTypes) {
            this.agoraRTCClient
                .setRemoteVideoStreamType(e[0], util_1.AgoraTranslate.NATIVE_RTCVIDEO_STREAM_TYPE2RemoteStreamType(e[1]))
                .then(() => { })
                .catch((e) => {
                util_1.AgoraConsole.error(`IrisClient.setup chain error: ${e}`);
            })
                .finally(() => { });
        }
        //
        let videoSourceType;
        if (irisClientState.publishCameraTrack == true) {
            videoSourceType =
                NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY;
        }
        else if (irisClientState.publishSecondaryCameraTrack == true) {
            videoSourceType =
                NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_SECONDARY;
        }
        else if (irisClientState.publishScreenTrack == true) {
            videoSourceType =
                NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY;
        }
        //如果当前轨道被特别指定了，那么就设置一下
        if (irisClientState.enabledDualStreamModes.has(videoSourceType)) {
            let streamMode = irisClientState.enabledDualStreamModes.get(videoSourceType);
            if (streamMode === null || streamMode === void 0 ? void 0 : streamMode.enabled) {
                this.agoraRTCClient
                    .enableDualStream()
                    .then(() => { })
                    .catch((e) => {
                    util_1.AgoraConsole.error(`IrisClient.setup chain error: ${e}`);
                })
                    .finally(() => { });
                if (streamMode.streamConfig != null) {
                    this.agoraRTCClient.setLowStreamParameter(util_1.AgoraTranslate.NATIVE_RTCSimulcastStreamConfig2LowStreamParameter(streamMode.streamConfig));
                }
            }
            else {
                this.agoraRTCClient
                    .disableDualStream()
                    .then(() => { })
                    .catch((e) => {
                    util_1.AgoraConsole.error(`IrisClient.setup chain error: ${e}`);
                })
                    .finally(() => { });
            }
        }
        else {
            if (irisClientState.enabledDualStreamMode) {
                this.agoraRTCClient
                    .enableDualStream()
                    .then(() => { })
                    .catch((e) => {
                    util_1.AgoraConsole.error(`IrisClient.setup chain error: ${e}`);
                })
                    .finally(() => { });
            }
        }
        //设置是否报告说话的人
        // AUDIT-v18: hook globalState. Se enableAudioVolumeIndication è stato
        // settato PRIMA del join, la chiamata originale a enableAudioVolumeIndicator
        // era no-op (agoraRTCClient non ancora creato). Rileggiamo globalState qui
        // per garantire hook post-join.
        if (irisClientState.enabledAudioVolumeIndication ||
            globalState.enableAudioVolumeIndication) {
            try {
                this.agoraRTCClient.enableAudioVolumeIndicator();
            }
            catch (e) {
                util_1.AgoraConsole.warn(`enableAudioVolumeIndicator post-join failed: ${e}`);
            }
        }
        //是否开启了加密
        if ((_a = irisClientState.encryptionConfig) === null || _a === void 0 ? void 0 : _a.enabled) {
            let encryptionConfig = irisClientState.encryptionConfig.config;
            let encryptionMode = util_1.AgoraTranslate.NATIVE_RTCENCRYPTION_MODE2EncryptionMode(encryptionConfig.encryptionMode);
            let salt = new Uint8Array(encryptionConfig.encryptionKdfSalt);
            this.agoraRTCClient.setEncryptionConfig(encryptionMode, encryptionConfig.encryptionKey, salt);
            //加密只有一次生效
            irisClientState.encryptionConfig.enabled = false;
        }
        //是否开启了鉴黄
        if (irisClientState.contentInspect != null) {
            this.agoraRTCClient
                .enableContentInspect(util_1.AgoraTranslate.NATIVE_RTCContentInspectConfig2InspectConfiguration(irisClientState.contentInspect))
                .then(() => { })
                .catch((e) => {
                util_1.AgoraConsole.error(`IrisClient.setup chain error: ${e}`);
            })
                .finally(() => { });
        }
        //是否开启了cloudProxy
        if (globalState.cloudProxy != null) {
            let proxyType = globalState.cloudProxy;
            if (proxyType == NATIVE_RTC.CLOUD_PROXY_TYPE.UDP_PROXY) {
                this.agoraRTCClient.startProxyServer(3);
            }
            else if (proxyType == NATIVE_RTC.CLOUD_PROXY_TYPE.TCP_PROXY) {
                this.agoraRTCClient.startProxyServer(5);
            }
        }
        this.clientEventHandler = new IrisClientEventHandler_1.IrisClientEventHandler(this, this._engine);
    }
    addLocalAudioTrack(trackPackage) {
        let find = this.audioTrackPackages.find((track) => track.track === trackPackage.track);
        if (find) {
            return;
        }
        this.audioTrackPackages.push(trackPackage);
        trackPackage.irisClient = this;
    }
    removeLocalAudioTrack(trackPackage) {
        for (let i = 0; i < this.audioTrackPackages.length; i++) {
            let _trackPackage = this.audioTrackPackages[i];
            if (_trackPackage.track == trackPackage.track) {
                this.audioTrackPackages.splice(i, 1);
                i--;
                break;
            }
        }
    }
    setLocalVideoTrack(trackPackage) {
        this.videoTrackPackage = trackPackage;
        trackPackage.irisClient = this;
    }
    clearLocalVideoTrack() {
        var _a;
        (_a = this.videoTrackPackage) === null || _a === void 0 ? void 0 : _a.dispose();
        this.videoTrackPackage = undefined;
    }
    release() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            // AUDIT-v18: double-release guard. Se release è già in corso o completato,
            // skip (no-op). Protegge da: leaveChannel → release + onConnectionLost →
            // release, due percorsi paralleli sullo stesso IrisClient.
            if (this._releasing || this._released) {
                util_1.AgoraConsole.debug(`IrisClient.release skip (already ${this._released ? 'released' : 'releasing'}) id=${this.id}`);
                return;
            }
            this._releasing = true;
            try {
                //client event
                if (this.clientEventHandler) {
                    try {
                        this.clientEventHandler.release();
                    }
                    catch (e) {
                        // AUDIT-v18: removeAllListeners può fallire se SDK è già in teardown.
                        // Non propagare: dobbiamo comunque completare il cleanup.
                        util_1.AgoraConsole.warn(`IrisClient clientEventHandler.release error: ${e}`);
                    }
                }
                if ((_a = this.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.channelName) {
                    try {
                        yield this._engine.clientHelper.leave(this.agoraRTCClient);
                        util_1.AgoraConsole.debug('client leave success');
                    }
                    catch (e) {
                        // AUDIT-v18: leave può fallire se disconnessi (network drop). Log e
                        // continua il cleanup — no throw per evitare orphan state.
                        util_1.AgoraConsole.warn(`IrisClient.release leave error: ${e}`);
                    }
                }
                for (let i = 0; i < this._engine.irisClientManager.remoteUserPackages.length; i++) {
                    let remoteUserPackage = this._engine.irisClientManager.remoteUserPackages[i];
                    if (((_b = remoteUserPackage.connection) === null || _b === void 0 ? void 0 : _b.channelId) == ((_c = this.connection) === null || _c === void 0 ? void 0 : _c.channelId) &&
                        ((_d = remoteUserPackage.connection) === null || _d === void 0 ? void 0 : _d.localUid) == ((_e = this.connection) === null || _e === void 0 ? void 0 : _e.localUid)) {
                        this._engine.irisClientManager.removeRemoteUserPackage(remoteUserPackage.uid);
                        i--;
                    }
                }
                //不删除通过engine.initialize创建的client
                if (((_f = this._engine.irisClientManager.irisClientList[0]) === null || _f === void 0 ? void 0 : _f.id) !== this.id) {
                    this._engine.irisClientManager.irisClientList = this._engine.irisClientManager.irisClientList.filter((item) => item.id != this.id);
                }
                this.audioTrackPackages = [];
                this.connection = {
                    channelId: '',
                    localUid: 0,
                };
                this.videoTrackPackage = undefined;
                this.agoraRTCClient = undefined;
                this._released = true;
            }
            finally {
                this._releasing = false;
            }
        });
    }
}
exports.IrisClient = IrisClient;
